export default __webpack_public_path__ + "static/media/element_85.e2cb035c.jpg";